export default __webpack_public_path__ + "static/media/like.180de3a1.svg";